(function () {
  var section = document.querySelector('.store-locator');
  if (!section) return;

  var apiKey = section.dataset.gmapsKey || '';
  var storefrontToken = section.dataset.storefrontToken || '';
  var searchRadius = parseInt(section.dataset.searchRadius) || 100;
  var defaultLat = parseFloat(section.dataset.defaultLat) || 45.2;
  var defaultLng = parseFloat(section.dataset.defaultLng) || 11.0;
  var searchRadiusMeters = searchRadius * 1000;

  var map, markers = [], infoWindow, clusterer;
  var allStores = [];
  var currentCenter = { lat: defaultLat, lng: defaultLng };
  var DAYS_MAP = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  var sidebar = section.querySelector('.store-locator__sidebar');
  var ct = section.querySelector('.store-locator__ct');

  var elements = {
    input: section.querySelector('[data-sl-select="search"]'),
    geoBtn: section.querySelector('[data-sl-select="geo"]'),
    list: section.querySelector('[data-sl-select="list"]'),
    mapFrame: section.querySelector('[data-sl-select="map"]'),
    filterType: section.querySelector('[data-sl-select="filter-type"]'),
    filterDay: section.querySelector('[data-sl-select="filter-day"]'),
    distanceSlider: section.querySelector('[data-sl-select="distance"]'),
    distanceValue: section.querySelector('[data-sl-select="distance-value"]'),
    searchResults: section.querySelector('[data-sl-select="search-results"]'),
    searchBtn: section.querySelector('[data-sl-select="search-btn"]'),
    template: section.querySelector('[data-sl-select="template"]'),
    toggles: section.querySelector('[data-sl-select="toggles"]'),
    toggleMap: section.querySelector('[data-sl-select="toggle-map"]'),
    toggleList: section.querySelector('[data-sl-select="toggle-list"]'),
    accordionDistance: section.querySelector('[data-sl-select="accordion-distance"]'),
    accordionStore: section.querySelector('[data-sl-select="accordion-store"]')
  };

  // --- Google Maps loader ---
  function loadGoogleMaps() {
    if (window.google && window.google.maps && window.google.maps.importLibrary) {
      return Promise.resolve();
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&v=weekly&loading=async&libraries=places,marker';
      script.async = true;
      script.onload = function () {
        if (window.google && window.google.maps) resolve();
        else reject(new Error('Google Maps not loaded'));
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  // --- MarkerClusterer loader ---
  function loadMarkerClusterer() {
    if (window.markerClusterer && window.markerClusterer.MarkerClusterer) {
      return Promise.resolve();
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js';
      script.onload = function () {
        if (window.markerClusterer && window.markerClusterer.MarkerClusterer) resolve();
        else reject(new Error('MarkerClusterer not loaded'));
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  // --- Parse hours JSON ---
  function parseHours(hoursJson) {
    if (!hoursJson) return null;
    try {
      if (typeof hoursJson === 'string') {
        return JSON.parse(hoursJson);
      }
      return hoursJson;
    } catch (e) {
      return null;
    }
  }

  // --- Get today's hours text ---
  function getTodayHours(hours) {
    var today = DAYS_MAP[new Date().getDay()];
    var todaySlots = hours[today];
    if (!todaySlots || todaySlots.length === 0) return { text: '', open: false };
    if (todaySlots[0] === 'closed') return { text: 'Chiuso', open: false };

    return {
      text: todaySlots.join(' / '),
      open: true
    };
  }

  // --- Get whole week hours (accordion content) ---
  var WEEK_ORDER = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  var WEEK_DAY_LABELS = {
    monday: 'Lunedì',
    tuesday: 'Martedì',
    wednesday: 'Mercoledì',
    thursday: 'Giovedì',
    friday: 'Venerdì',
    saturday: 'Sabato',
    sunday: 'Domenica'
  };

  function getWeekHoursRows(hours) {
    var today = DAYS_MAP[new Date().getDay()];
    return WEEK_ORDER.map(function (day) {
      var slots = hours[day];
      var closed = !slots || slots.length === 0 || slots[0] === 'closed';
      var text = !slots || slots.length === 0 ? '—' : (closed ? 'Chiuso' : slots.join(' / '));
      var todayClass = day === today ? ' __today' : '';
      if (closed) todayClass += ' __closed';
      else if (day === today) todayClass += ' __open';
      return '<div class="store-locator__hours__row' + todayClass + '"><span>' + WEEK_DAY_LABELS[day] + '</span><span>' + text + '</span></div>';
    }).join('');
  }

  // --- Check if store is open now ---
  function isOpenNow(hours) {
    var now = new Date();
    var today = DAYS_MAP[now.getDay()];
    var slots = hours[today];
    if (!slots || slots.length === 0) return false;
    if (slots[0] === 'closed') return false;

    var currentMinutes = now.getHours() * 60 + now.getMinutes();

    for (var i = 0; i < slots.length; i++) {
      var parts = slots[i].split('-');
      if (parts.length !== 2) continue;
      var openParts = parts[0].split(':');
      var closeParts = parts[1].split(':');
      var openMin = parseInt(openParts[0]) * 60 + parseInt(openParts[1]);
      var closeMin = parseInt(closeParts[0]) * 60 + parseInt(closeParts[1]);
      if (currentMinutes >= openMin && currentMinutes < closeMin) return true;
    }
    return false;
  }

  // --- Check if store is open on specific day ---
  function isOpenOnDay(hours, dayKey) {
    var slots = hours[dayKey];
    if (!slots || slots.length === 0) return false;
    return slots[0] !== 'closed';
  }

  // --- Store type detection ---
  function getStoreType(name) {
    return name && name.indexOf('Naima') === 0 ? 'naima' : 'beauty-star';
  }

  // --- Store data (GraphQL) ---
  async function fetchAllStores() {
    var language = (document.documentElement.lang || 'IT').toUpperCase();
    var stores = [];
    var hasNextPage = true;
    var cursor = null;

    while (hasNextPage) {
      try {
        var response = await fetch('https://beauty-star-replatforming.myshopify.com/api/2026-07/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontToken
          },
          body: JSON.stringify({
            query: 'query GetStores($lang: LanguageCode, $cursor: String) @inContext(language: $lang) { metaobjects(type: "stores", first: 250, after: $cursor) { pageInfo { hasNextPage, endCursor } nodes { name: field(key: "name") { value } city: field(key: "city") { value } address: field(key: "address") { value } phone: field(key: "phone") { value } latitude: field(key: "latitude") { value } longitude: field(key: "longitude") { value } province: field(key: "province") { value } code: field(key: "code") { value } hours: field(key: "hours") { value } } } }',
            variables: { lang: language, cursor: cursor }
          })
        });
        var res = await response.json();

        if (res.errors) {
          console.error('GraphQL errors:', res.errors);
          break;
        }
        var meta = res.data && res.data.metaobjects;
        if (!meta) break;
        stores.push.apply(stores, meta.nodes);
        hasNextPage = meta.pageInfo.hasNextPage;
        cursor = meta.pageInfo.endCursor;
      } catch (e) {
        console.error('Store fetch error:', e);
        break;
      }
    }

    return stores.map(function (item) {
      var name = item.name ? item.name.value : '';
      var hours = parseHours(item.hours ? item.hours.value : null);

      return {
        name: name,
        city: item.city ? item.city.value : '',
        address: item.address ? item.address.value : '',
        phone: item.phone ? item.phone.value : '',
        province: item.province ? item.province.value : '',
        code: item.code ? item.code.value : '',
        latitude: parseFloat(item.latitude ? item.latitude.value : 0) || 0,
        longitude: parseFloat(item.longitude ? item.longitude.value : 0) || 0,
        hours: hours || {},
        storeType: getStoreType(name)
      };
    });
  }

  // --- Custom autocomplete (Places API) ---
  function initSearch() {
    if (!elements.input) return;

    var autocompleteService;
    var geocoder = new google.maps.Geocoder();
    var resultsEl = elements.searchResults;
    var debounceTimer;

    function clearResults() {
      if (resultsEl) resultsEl.innerHTML = '';
    }

    function renderSuggestions(predictions) {
      if (!resultsEl) return;
      resultsEl.innerHTML = '';
      if (!predictions || !predictions.length) return;

      predictions.forEach(function (p) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'store-locator__search__result';
        btn.textContent = p.description;
        btn.addEventListener('click', function () {
          selectPlace(p.place_id);
        });
        resultsEl.appendChild(btn);
      });
    }

    function geocodeAndCenter(location) {
      geocoder.geocode(location, async function (results, status) {
        if (status !== 'OK' || !results.length) return;
        currentCenter = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        };
        if (allStores.length === 0) {
          allStores = await fetchAllStores();
        }
        applyAllFilters();
        map.setCenter(currentCenter);
        map.setZoom(10);
        applyDesktopOffset();
      });
    }

    function selectPlace(placeId) {
      clearResults();
      elements.input.value = '';
      geocodeAndCenter({ placeId: placeId });
    }

    function doSearch() {
      var query = elements.input.value.trim();
      if (!query) { clearResults(); return; }

      if (!autocompleteService) {
        autocompleteService = new google.maps.places.AutocompleteService();
      }

      autocompleteService.getPlacePredictions(
        { input: query, language: 'it' },
        function (predictions, status) {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            renderSuggestions(predictions);
          } else {
            clearResults();
          }
        }
      );
    }

    elements.input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(doSearch, 250);
    });

    elements.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var query = elements.input.value.trim();
        if (!query) return;
        clearResults();
        geocodeAndCenter({ address: query });
      }

      if (e.key === 'Escape') {
        clearResults();
      }
    });

    if (elements.searchBtn) {
      elements.searchBtn.addEventListener('click', function () {
        var query = elements.input.value.trim();
        if (!query) return;
        clearResults();
        geocodeAndCenter({ address: query });
      });
    }

    document.addEventListener('click', function (e) {
      if (resultsEl && !elements.input.contains(e.target) && !resultsEl.contains(e.target)) {
        clearResults();
      }
    });
  }

  // --- Radius filter ---
  function filterByRadius(stores, center) {
    return stores.filter(function (store) {
      var pos = new google.maps.LatLng(store.latitude, store.longitude);
      var dist = google.maps.geometry.spherical.computeDistanceBetween(
        pos,
        new google.maps.LatLng(center.lat, center.lng)
      );
      store._distance = dist;
      return dist <= searchRadiusMeters;
    });
  }

  // --- Additional filters ---
  function applyStoreTypeFilter(stores) {
    var type = elements.filterType ? elements.filterType.value : 'all';
    if (type === 'all') return stores;
    return stores.filter(function (s) { return s.storeType === type; });
  }

  function applyDayFilter(stores) {
    var day = elements.filterDay ? elements.filterDay.value : 'all';
    if (day === 'all') return stores;
    var dayKey = day === 'today' ? DAYS_MAP[new Date().getDay()] : day;
    return stores.filter(function (s) { return isOpenOnDay(s.hours, dayKey); });
  }

  function sortByDistance(stores) {
    return stores.sort(function (a, b) { return (a._distance || 0) - (b._distance || 0); });
  }

  function applyAllFilters() {
    var radiusFiltered = filterByRadius(allStores, currentCenter);
    var typeFiltered = applyStoreTypeFilter(radiusFiltered);
    var dayFiltered = applyDayFilter(typeFiltered);
    var filteredStores = sortByDistance(dayFiltered);

    addMarkers(filteredStores);
    renderList(filteredStores);
  }

  function applyDesktopOffset() {
    var isMobile = window.matchMedia('(max-width: 1023.98px)').matches;
    if (!isMobile && elements.mapFrame) {
      map.panBy(-(elements.mapFrame.offsetWidth * 0.3), 0);
    }
  }

  function panToStore(latLng) {
    map.setCenter(latLng);
    map.setZoom(15);
    applyDesktopOffset();
  }

  function buildInfoWindowContent(store) {
    return '<div class="store-locator__iw">' +
      '<strong>' + store.name + '</strong><br>' +
      store.address.replace(/\n/g, '<br>') + '<br>' +
      (store.city || '') + (store.province ? ' (' + store.province + ')' : '') +
      '</div>';
  }

  function openInfoWindow(store) {
    infoWindow.setContent(buildInfoWindowContent(store));
    infoWindow.setPosition({ lat: store.latitude, lng: store.longitude });
    infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -15), maxWidth: 300 });
    infoWindow.open(map);
  }

  // --- Marker cluster icon ---
  function clusterIcon(count) {
    var size = 60;
    var isMobile = window.matchMedia('(max-width: 1023.98px)').matches;
    if (!isMobile && elements.mapFrame) {
      size = 70;
    }
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70">' +
      '<circle cx="35" cy="35" r="34" fill="#1D2353" stroke="white" stroke-width="2"/>' +
      '<text x="35" y="35" text-anchor="middle" dominant-baseline="central" fill="#ffffff" font-family="Fraunces, serif" font-weight="400" font-size="25">' + count + '</text>' +
      '</svg>';
    return {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg),
      anchor: new google.maps.Point(35, 35),
      scaledSize: new google.maps.Size(size, size)
    };
  }

  // --- Markers ---
  function addMarkers(stores) {
    if (!clusterer) return;
    clusterer.clearMarkers();
    markers = [];

    var bsPinSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="52" viewBox="0 0 625 813">' +
      '<path d="M625 312.5C625 593.75 312.5 812.5 312.5 812.5C312.5 812.5 0 593.75 0 312.5C0 229.62 32.924 150.135 91.53 91.53C150.136 32.925 229.62 0 312.5 0C395.38 0 474.865 32.924 533.47 91.53C592.075 150.136 625 229.62 625 312.5Z" fill="#1D2353"/>' +
      '<path d="M187.785 281.288L246.897 273.298C261.275 271.7 269.264 265.308 275.654 252.523L302.814 198.191C307.607 188.603 315.595 188.603 320.388 198.191L347.547 252.523C353.938 265.308 361.926 271.7 376.305 273.298L437.015 281.288C448.198 282.886 449.796 290.876 441.807 298.866L398.672 340.414C389.086 350.002 385.891 359.59 387.488 373.972L397.074 433.099C398.672 444.285 392.281 449.079 382.696 444.285L329.974 415.521C317.193 409.129 307.607 409.129 294.826 415.521L242.104 444.285C232.519 449.079 226.128 444.285 227.726 433.099L237.312 373.972C238.909 359.59 237.312 350.002 226.128 340.414L182.993 298.866C175.004 290.876 176.601 282.886 187.785 281.288Z" fill="#FFB4AB"/>' +
      '</svg>';

    var bsIcon = {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(bsPinSvg),
      scaledSize: new google.maps.Size(36, 47),
      anchor: new google.maps.Point(18, 45)
    };

    stores.forEach(function (store) {
      var marker = new google.maps.Marker({
        position: { lat: store.latitude, lng: store.longitude },
        icon: bsIcon,
        title: store.name
      });

      marker.addListener('click', function () {
        openInfoWindow(store);
        panToStore({ lat: store.latitude, lng: store.longitude });

        var cards = elements.list.querySelectorAll('[data-sl-card="name"]');
        var idx = stores.indexOf(store);
        if (cards[idx]) {
          cards[idx].closest('.store-locator__card').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          cards[idx].closest('.store-locator__card').classList.add('__highlight');
          setTimeout(function () {
            cards[idx].closest('.store-locator__card').classList.remove('__highlight');
          }, 2000);
        }
      });

      markers.push(marker);
    });

    clusterer.addMarkers(markers);
  }

  // --- List render ---
  function renderList(stores) {
    if (!elements.list || !elements.template) return;
    elements.list.innerHTML = '';

    stores.forEach(function (store) {
      var clone = elements.template.content.cloneNode(true);

      var nameEl = clone.querySelector('[data-sl-card="name"]');
      var addrEl = clone.querySelector('[data-sl-card="address"]');
      var phoneEl = clone.querySelector('[data-sl-card="phone"]');
      var distEl = clone.querySelector('[data-sl-card="distance"]');
      var hoursTextEl = clone.querySelector('[data-sl-card="hours-text"]');
      var hoursWeekEl = clone.querySelector('[data-sl-card="hours-week"]');
      var statusDot = clone.querySelector('[data-sl-card="status-dot"]');
      var statusText = clone.querySelector('[data-sl-card="status-text"]');
      var dirLink = clone.querySelector('[data-sl-card="directions"]');

      if (nameEl) nameEl.textContent = store.name;
      if (addrEl) addrEl.textContent = (store.address || '') + (store.address ? ', ' : '') + (store.city || '') + (store.province ? ' (' + store.province + ')' : '');

      if (phoneEl && store.phone) {
        phoneEl.href = 'tel:' + store.phone;
        phoneEl.querySelector('span').textContent = store.phone;
      } else if (phoneEl) {
        phoneEl.remove();
      }

      if (distEl) {
        var d = store._distance;
        distEl.textContent = d ? (d < 1000 ? Math.round(d) + ' m' : (d / 1000).toFixed(1) + ' km') : '';
      }

      var todayHours = getTodayHours(store.hours);
      var openNow = isOpenNow(store.hours);

      if (statusDot) {
        statusDot.className = 'info-status__dot ' + (openNow ? '__open' : '__closed');
      }
      if (statusText) {
        statusText.textContent = openNow ? 'Aperto' : 'Chiuso';
      }
      if (hoursTextEl) {
        hoursTextEl.textContent = todayHours.text || '—';
      }
      if (hoursWeekEl) {
        hoursWeekEl.innerHTML = getWeekHoursRows(store.hours);
      }
      if (dirLink) {
        dirLink.href = 'https://www.google.com/maps?saddr=My+Location&daddr=' + store.latitude + ',' + store.longitude;
      }

      var hoursToggle = clone.querySelector('.store-locator__hours');
      if (hoursToggle) {
        hoursToggle.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      }

      var card = clone.querySelector('.store-locator__card');
      if (card) {
        card.addEventListener('click', function () {
          // In list view on mobile, switch to map first
          if (ct && ct.classList.contains('__list-view')) {
            ct.classList.remove('__list-view');
            if (elements.toggleMap) elements.toggleMap.classList.add('__active');
            if (elements.toggleList) elements.toggleList.classList.remove('__active');
            if (map) google.maps.event.trigger(map, 'resize');
          }
          panToStore({ lat: store.latitude, lng: store.longitude });
          openInfoWindow(store);
        });
      }

      elements.list.appendChild(clone);
    });
  }

  // --- Map init ---
  async function initMap(center) {
    await google.maps.importLibrary('maps');
    await google.maps.importLibrary('geometry');
    await google.maps.importLibrary('marker');

    infoWindow = new google.maps.InfoWindow({ shouldFocus: false });

    map = new google.maps.Map(elements.mapFrame, {
      cameraControl: false,
      center: center,
      zoom: 8,
      mapTypeControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT
      },
      scaleControl: false,
      streetViewControl: false,
      fullscreenControl: false
    });

    clusterer = new markerClusterer.MarkerClusterer({
      map: map,
      algorithm: new markerClusterer.SuperClusterAlgorithm({ radius: 80 }),
      renderer: {
        render: function (cluster) {
          var count = cluster.count;
          return new google.maps.Marker({
            position: cluster.position,
            icon: clusterIcon(count),
            zIndex: 1000 + count
          });
        }
      },
      onClusterClick: function (event, cluster) {
        map.fitBounds(cluster.bounds);
        if (map.getZoom() > 16) map.setZoom(16);
        applyDesktopOffset();
      }
    });

    if (allStores.length) {
      applyAllFilters();
    }

    applyDesktopOffset();

    section.classList.add('__loaded');
    map.addListener('click', function () { infoWindow.close(); });
  }

  // --- Geolocation ---
  function bindGeolocation() {
    if (!elements.geoBtn) return;
    elements.geoBtn.addEventListener('click', function () {
      if (!navigator.geolocation) {
        alert('Geolocalizzazione non supportata.');
        return;
      }
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          currentCenter = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          if (map) {
            applyAllFilters();
            map.setCenter(currentCenter);
            map.setZoom(10);
            applyDesktopOffset();
          }
        },
        function () { alert('Impossibile ottenere la posizione.'); }
      );
    });
  }

  // --- Filter change handlers ---
  function bindFilters() {
    var handler = function () {
      if (!map || !allStores.length) return;
      applyAllFilters();
    };

    if (elements.filterType) elements.filterType.addEventListener('change', handler);
    if (elements.filterDay) elements.filterDay.addEventListener('change', handler);
    if (elements.distanceSlider) {
      elements.distanceSlider.addEventListener('input', function () {
        var km = parseInt(this.value);
        searchRadiusMeters = km * 1000;
        if (elements.distanceValue) {
          elements.distanceValue.textContent = km + ' km';
        }
        if (map && allStores.length) applyAllFilters();
      });
    }
  }

  // --- Toggle map/list view (mobile) ---
  function bindToggles() {
    if (!elements.toggles || !elements.toggleMap || !elements.toggleList) return;

    elements.toggleMap.addEventListener('click', function () {
      if (ct) ct.classList.remove('__list-view');
      elements.toggleMap.classList.add('__active');
      elements.toggleList.classList.remove('__active');
      if (map) google.maps.event.trigger(map, 'resize');
    });

    elements.toggleList.addEventListener('click', function () {
      if (ct) ct.classList.add('__list-view');
      elements.toggleList.classList.add('__active');
      elements.toggleMap.classList.remove('__active');
    });
  }

  // --- Init ---
  async function init() {
    try {
      await loadGoogleMaps();
      await loadMarkerClusterer();
      allStores = await fetchAllStores();
      initSearch();
      bindToggles();
      await initMap(currentCenter);
      bindFilters();
    } catch (err) {
      console.error('Store locator init failed:', err);
    }
  }

  bindGeolocation();
  init();
})();
